import { capitalize } from "lodash";
import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/shared/uikit/Button";
import { Typography } from "@circle-react-shared/uikit/Typography";
import type { InvitationCardProps } from "../../../types/ChatCard";

export const InvitationCard = ({ title, url, params }: InvitationCardProps) => (
  <div
    className="bg-primary border-primary flex w-[368px] min-w-0 flex-1 flex-col items-start gap-3 self-stretch rounded-2xl border p-4"
    style={{ boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" }}
  >
    <Typography.BodySm weight="font-bold" color="text-dark">
      {title}
    </Typography.BodySm>

    <div className="flex flex-col gap-2">
      {Object.entries(params).map(([key, value]) => (
        <div key={key} className="flex flex-row gap-2">
          <Typography.BodySm weight="font-bold" color="text-dark">
            {`• ${capitalize(key)}: `}
          </Typography.BodySm>
          <Typography.BodySm color="text-dark">{value}</Typography.BodySm>
        </div>
      ))}
    </div>

    <Button
      onClick={() => {
        window.location.href = url;
      }}
      variant="circle"
      className="w-full"
    >
      <Typography.BodySm weight="font-medium" color="text-primary">
        {t("help_widget.copilot.chat_card.preview_button")}
      </Typography.BodySm>
    </Button>
  </div>
);
